module.exports = __webpack_public_path__ + "img/logo.c70e33af.png";